import React from "react";
import { Router } from "@reach/router";
import { graphql, useStaticQuery } from "gatsby";
import DinteroCheckout from "./dintero-checkout";

const Checkout = () => {
  const {
    wp: {
      wcSettings: { checkoutUrl },
    },
  } = useStaticQuery(graphql`
    query {
      wp {
        wcSettings {
          checkoutUrl
        }
      }
    }
  `);

  return (
    <Router style={{ width: "100%" }}>
      <DinteroCheckout path={checkoutUrl} />
    </Router>
  );
};

export default Checkout;
